import React, { useState} from 'react';
import {Popup} from "../../../ui/popup/popup";

const LivePagePopup = (props:any) => {
    const popup = props && props.props ? props.props : null;
    const [isShow, setIsShow] = useState(true);
    const showPopup = () => {
        if (isShow){
            setIsShow(false);
        }
        else {
            setIsShow(true);
        }
    }
    console.log(isShow);
    return (
        <>
            {
                popup &&
                       <div className={ !isShow ? 'hidden' : ''} >
                           <Popup width="300px" height="auto" close={showPopup}>
                            <div className="pb-4">
                                <div className="w-full bg-gray-100 p-2 flex items-center justify-center mt-4">
                                    <img src={popup.thumb} alt="product" />
                                </div>
                                <div className="font-bold">{popup.skuName}</div>
                                <div className="py-4">{popup.documentPageDescription}</div>
                                <a href={popup.documentUrlPath} target="_blank" rel="noreferrer" >{`Explore >`} </a>
                            </div>
                        </Popup>
                       </div>
                }
        </>
    )
}
export default LivePagePopup;